module.exports = __webpack_public_path__ + "img/3-3.3a4b1246.jpg";